import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import ProvideAppContext from "./AppContext";
import NavBar from "./NavBar";

import {
    PublicClientApplication,
    EventType,
    EventMessage,
    AuthenticationResult
} from "@azure/msal-browser";

import config from "./config";
import { MsalProvider } from "@azure/msal-react";

declare global {
    interface Window {
        $: any;
    }
}

const isTestChat = new URLSearchParams(window.location.search).get("Session.IsTestChat");

const msalInstance = new PublicClientApplication(({
    auth: {
        clientId: config.appId,
        redirectUri: config.redirectUri
    },
    cache: {
        cacheLocation: "sessionStorage",
        storeAuthStateInCookie: true
    }
}) as any);
// Check if there are already accounts in the browser session
// If so, set the first account as the active account
const accounts = msalInstance.getAllAccounts();
if (accounts && accounts.length > 0) {
    msalInstance.setActiveAccount(accounts[0]);
}

msalInstance.addEventCallback((event: EventMessage) => {
    if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
        // Set the active account - this simplifies token acquisition
        const authResult = event.payload as AuthenticationResult;
        msalInstance.setActiveAccount(authResult.account);
    }
});


ReactDOM.render(
    <React.StrictMode>
        <MsalProvider instance={msalInstance}>
            <ProvideAppContext >
                <div id="app-grid">
                    <NavBar />
                    <div className="overflow-auto">
                        {isTestChat &&
                            <div id="test-chat-status" className="position-absolute p-1" style={{ zIndex: 20 }} >
                                <small className="border px-1 bg-white rounded opacity-75" style={{ fontSize: "80%" }}>Test Chat</small>
                            </div>
                        }
                        <App />
                    </div>
                </div>
            </ProvideAppContext>
        </MsalProvider>
    </React.StrictMode>,
    document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
